import styled from "styled-components";

export const SearchResultTag = styled("span")`
  > * {
    margin-right: 5px;
  }
`;
SearchResultTag.displayName = "SearchResultTag";
